import {
  getMenuList,
  getAdminDetail,
  getCredential,
  getMenuSubById,
  getLeftMenus
} from "@/utils/api";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      subMenu: [],
    };
  },
  computed: {
    ...mapState(["menuList", "mobile"]),
  },

  methods: {
    // 用户凭证
    async getPermission(arr) {
      let res = await getCredential(this.mobile); 
      if (res.sub && res.identity == 3) { //判断是否是服务商子账号
        this.setSub(res.sub)
        this.USER_NAME(res.sub.nickname);
        let subId = res.sub.id;
        if (subId) {
          let result = await getMenuSubById(subId);
          if (result.status == 1) {
            this.subMenu = result.result;
            this.forChildren(arr)
          } 
        }
      }else{
        this.forChildren(arr)
      }
    },

    ...mapMutations(["setMenuList", "NEW_MENU","setSub","USER_NAME"]),
    /*权限菜单*/
    async getMenuList() {
      let res = await getMenuList();
      if (res.status == 1) {
        let that = this;
        if (this.$store.state.choice == 3) {  // 服务商
          this.getPermission(res.result);
        }else{
          that.forChildren(res.result);
        }  
      } else {
        this.$router.push({
          path: "/setup/menus",
        });
      }
      getLeftMenus().then(res => {
        console.log('菜单权限====', res);
        if (res.status == '1') {
          let _arr = res.result;
          _arr.forEach((x, index) => {
            x.menu_id = x.menu_id.toString();
            x.parent_id = x.parent_id.toString();
            if (x.children_menus?.length) {
              x.children_menus.forEach((y, index2) => {
                y.menu_id = y.menu_id.toString();
                y.parent_id = y.parent_id.toString();
                y.location = `${index+2}-${index2+1}`;
                y.path = x.path
              })
            }
          })
          this.$store.commit("setMenuScrollBarList", _arr)
        }
      })
    },

    /*处理路由 规格*/
    mergeRoutes(subs) {
      if (subs) {
        let route = new Array();
        let menu = subs;
        let children = new Array();
        menu.map((item, index) => {
          let temp = {
            path: item.path,
            name: item.name,
            component: (resolve) =>
              require([`@/view${item.path}.vue`], resolve),
            meta: {
              title: item.name,
            },
            id: item.menu_id,
            is_navigation: item.is_navigation,

            children: [],
            icon: item.icon,
          };
          if (item.children_menus) {
            temp.children = this.setChildren(item);
          }
          route.push(temp);
        });
        return route;
      }
    },

    setChildren(data) {
      let route = new Array();
      let children = new Array();
      let menu = data.children_menus;
      menu.map((item, index) => {
        let temp = {
          path: item.path,
          name: item.name,
          component: (resolve) => require([`@/view${item.path}.vue`], resolve),
          iscom: `@/view${item.path}.vue`,
          meta: {
            title: item.name,
          },
          children: [],
          is_navigation: item.is_navigation,
          icon: item.icon,
          id: item.menu_id,
          parent_id: item.parent_id,
        };
        if (item.children_menus) {
          temp.children = this.mergeRoutes(item.children_menus);
        }
        route.push(temp);
      });
      return route;
    },

    /*筛选是否还有子集*/
    forChildren(arr) {
      let route = new Array();
      arr.map((item, index) => {
        let path = item.path.split("/");
        let temp = {
          path: item.path,
          name: item.name,
          component: (resolve) =>
            require([`@/view/${path[1]}/index.vue`], resolve),
          //iscom:`@/view/${path[1]}/index.vue`,
          redirect: "",
          meta: {
            title: item.name,
          },
          children: [],
          is_navigation: item.is_navigation,
          icon: item.icon,
          id: item.menu_id,
          parent_id: item.parent_id,
        };
        let children_menus =
          item.name == "服务商" && this.subMenu.length
            ? this.subMenu
            : item.children_menus;
        if (children_menus) {
          temp.children = this.mergeRoutes(children_menus);
        }
        temp.redirect = this.getPath(children_menus);
        route.push(temp);
      });
      // this.$router.addRoute(route[0])
      this.$router.addRoutes([{
        path: '',
        component: (resolve) => require([`@/layout/index.vue`], resolve),
        children: route
      }]);

      if (route) {
        if (this.$route.path == "/choice") {
          this.$router.push({
            path: route[0].path,
          });
        }
      } else {
        this.$router.push({
          path: "/setup/menus",
        });
      }
      // console.log("route-------:",route)
      this.setMenuList(route);
    },

    getPath(arr) {
      // console.log("getPath----:",arr)
      let path;
      if (arr) {
        arr.find((item, index) => {
          if (item.is_navigation == 1) {
            return (path = item.path);
          }
        });
        // console.log("path----:", path);
        return path;
      }
    },
  },
};
